import { HttpParams } from '@angular/common/http';
import { ApiService } from '@libs/core/base-config';
import { omitUndefinedValues } from '@libs/core/lib/utils/utils';
import { Dtos, walletTransactionsListResponseSchema } from '@libs/mtjr/shared/generated/types';
import { map } from 'rxjs';

export function walletTransactionsList(apiService: ApiService, queryParams: Dtos.WalletTransactionsListQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/wallet-transactions/wallet-transactions-list`, { params })
    .pipe(map((data) => walletTransactionsListResponseSchema().parse(data)));
}
